module.exports = __webpack_public_path__ + "static/media/12.7c0822dc.jpg";